module.exports = __webpack_public_path__ + "assets/webgl/art_050_L0.jpg.pvr.98a38e86.ktx";